import { useEffect, useState } from "react";

// true mientras el usuario escribe en un campo en pantallas pequeñas (para ocultar botones flotantes)
export function useTypingOnMobile() {
  const [typing, setTyping] = useState(false);
  useEffect(() => {
    const isField = (el) => el && (el.tagName === "INPUT" || el.tagName === "TEXTAREA" || el.isContentEditable);
    const onIn = (e) => { if (window.innerWidth < 768 && isField(e.target)) setTyping(true); };
    const onOut = () => setTimeout(() => setTyping(isField(document.activeElement) && window.innerWidth < 768), 50);
    document.addEventListener("focusin", onIn);
    document.addEventListener("focusout", onOut);
    return () => { document.removeEventListener("focusin", onIn); document.removeEventListener("focusout", onOut); };
  }, []);
  return typing;
}

export const OVERLAY_HIDDEN_PATHS = ["/asistente", "/chat"];
